import { Text } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { Document, ResourceForm } from "@medplum/react";
import { useMedplum } from "@medplum/react"; 

const NewPatientComponent = (): JSX.Element => {
  const medplum = useMedplum(); 
  const handleSubmit = (formData: any) => {
    medplum
      .createResource(formData)
      .then((result) => {
              showNotification({
                color: "green",
                message: "Patient created successfully",
                autoClose: true,
              });
      })
      .catch((error) => {
        console.error("Error creating resource:", error);
         showNotification({
           color: "red",
           message: error.message,
           autoClose: true,
         });
      });
  };
  return (
    <Document>
      <Text fw={700} size="xl" mb={"20px"}>
        Create New Patient
      </Text>
        
      <ResourceForm
        defaultValue={{
          resourceType: "Patient",
          id: "",
          name: [{}],
        }}
        onSubmit={handleSubmit}
      />
    </Document>
  );
};

export default NewPatientComponent;
